import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { StoreContext } from './StoreContext';

export const PageContext = createContext(null);

export const PageProvider = observer(({ children }) => {
    const location = useLocation();
    const rootStore = useContext(StoreContext);
    const [pageStore, setPageStore] = useState(null);
    
    // Создаем/обновляем стор страницы при изменении роута
    useEffect(() => {
        const currentPath = location.pathname;
        
        // Генерируем стор для текущей страницы через MSTModelStore
        const newPageStore = rootStore.models.createPageStore(currentPath);
        setPageStore(newPageStore);
        
        // Загружаем данные если стор создан
        if (newPageStore && newPageStore.load) {
            // Определяем, является ли страница списком (коллекцией)
            // Список - это страница без id в URL и с CollectionModel
            const isListPage = !location.pathname.includes('/edit/') &&
                              !location.pathname.includes('/new') &&
                              newPageStore.items !== undefined;

            // Для страниц-списков используем frozen режим чтобы избежать ошибок с computed полями
            if (isListPage) {
                newPageStore.load({ frozen: true });
            } else {
                newPageStore.load();
            }
        }
        
        // Очистка при размонтировании не нужна - стор кешируется
        // Очистка происходит при reset() всего rootStore
    }, [location.pathname, rootStore.models]);
    
    // Контекст страницы с дополнительной информацией
    // НЕ используем useMemo чтобы computed поля обновлялись реактивно!
    const pageContext = {
        store: pageStore,
        path: location.pathname,
        routeConfig: pageStore?.routeConfig,
        apiPath: pageStore?.routeConfig?.api || pageStore?.apiEndpoint,
        specEndpoints: rootStore.models?.schemas?.routes?.specEndpoints,
        modelName: pageStore?.entityName || pageStore?.modelName, // entityName для коллекций
        modelSchema: pageStore?.modelSchema,
        isSingleton: pageStore?.isSingleton,
        canCreate: pageStore?.canCreate,
        canUpdate: pageStore?.canUpdate, 
        canDelete: pageStore?.canDelete,
        canRead: pageStore?.canRead,
        hasSpecialOperations: pageStore?.hasSpecialOperations
    };
    
    return (
        <PageContext.Provider value={pageContext}>
            {children}
        </PageContext.Provider>
    );
});